import { createContext, useContext } from 'react';

/**
 * True inside a `<MenuHighlight>` — i.e. a list where ONE shared indicator
 * slides between rows instead of every row painting its own hover wash.
 *
 * `MenuListItem` reads this to drop its own hover / focus background (they
 * would double up with the indicator). Pressed stays on the row: a press
 * should register instantly and locally, not travel.
 *
 * Web-only in practice — the native `MenuHighlight` never provides it, so
 * native rows keep their own press states.
 */
export const MenuHighlightContext = createContext(false);

/** Whether the enclosing list paints a shared sliding highlight. */
export function useMenuHighlight(): boolean {
  return useContext(MenuHighlightContext);
}
